import { render } from "./SponsorCodes.vue?vue&type=template&id=80a65726&scoped=true"
import script from "./SponsorCodes.vue?vue&type=script&lang=js"
export * from "./SponsorCodes.vue?vue&type=script&lang=js"

import "./SponsorCodes.vue?vue&type=style&index=0&id=80a65726&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a65726"]])

export default __exports__